








































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Form, {Send} from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import { cloneDeep } from 'lodash';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

import CurrencyMixin from '@/components/helpers/currency-mixin';

import moment from 'moment';
import CampaignApi from '@/services/rest/bemob/campaign';
const md5 = require('md5');


@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons,
    ErrorAggregator,
  }
})
export default class UpdateCostDialog extends mixins<Form, CurrencyMixin>(Form, CurrencyMixin) {
  step: number = 1;
  show: boolean = false;
  loading: boolean = false;
  campaign_id: string = '';
  name: string = '';

  errors: any[] = [];
  errorsControlActive: boolean = false;

  campaignApi: CampaignApi = new CampaignApi();

  form: any = this.getDefaultForm();

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  getDefaultForm() {
    return {
      timezone: this.$store.state.user.defaultTimezone,
      restore: 0
    }
  }

  get currencyIcon(){
    return this.currencies[this.form.currencyId];
  }

  async mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    this.$store.commit('loading', true);
    await this.load();

    this.oldHash = this.getCurrentHash()
    this.show = true;
    this.$store.commit('loading', false);
  }

  resetErrorsWithControl() {
    this.errors = [];
    this.errorsControlActive = false;

    this.resetErrors();
  }

  load(): any {
    this.campaign_id = this.$store.getters.selectedItem.id;

    const campaign = this.campaignApi.get(this.campaign_id).then((data: any) => {
      const { to, from } = this.$store.getters.tableQueryForCurrentTab;
      const now = moment();

      this.name = data.name;
      this.form = {
        ...this.getDefaultForm(),
        startTimestamp: from || now.format('YYYY-MM-DD 00:00:00'),
        endTimestamp: to || now.format('YYYY-MM-DD 23:59:59'),
        cost: 0,
        //cost: data.costValue,
        currencyId: data.currencyId,
      };

      return data;
    });

    return Promise.all([campaign] as any)
  }

  close() {
    this.$emit('close');
  }

  get timezoneList() {
    return this.$store.state.timezoneList;
  }

  handleUpdatePeriod(value: TimeRange) {
    this.form.startTimestamp = value.from;
    this.form.endTimestamp = value.to;
  }

  @Send()
  submit() {
    let form = cloneDeep(this.form);
    form.restore = Number(this.form.restore);

    this.resetErrorsWithControl();

    return this.campaignApi.postUpdateCost(this.campaign_id, form).then(() => {
      this.close()
    }).catch((error: any) => {
      return Promise.reject(error);
    })

  }
}
